import { render, staticRenderFns } from "./DialogInfoCliente.vue?vue&type=template&id=1cffa045&"
import script from "./DialogInfoCliente.vue?vue&type=script&lang=js&"
export * from "./DialogInfoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports